import { Controller } from '@hotwired/stimulus';
import DfApi from '@/js/modules/df_api';

const api = () => new DfApi();

export default class extends Controller {
  static values = { presetId: Number };

  async load(event) {
    event.preventDefault();

    const editor = this.#findEditor();

    if (!editor) {
      return;
    }

    try {
      const content = await this.#fetchPresetContent();
      editor.setAttribute('data-js-update-content', content);
    } catch (error) {
      console.error('Failed to load preset:', error);
    }
  }

  #findEditor() {
    return document.querySelector('[data-controller*="tiptap-editor"] .tiptap');
  }

  async #fetchPresetContent() {
    const editorElement = document.querySelector('[data-controller*="tiptap-editor"]');
    const projectId = editorElement?.dataset.tiptapEditorProjectId;
    const contractId = editorElement?.dataset.tiptapEditorContractId;
    const response = await api().getPreset(this.presetIdValue, projectId, contractId);
    const { details } = await response.json();
    return details;
  }
}
